/* eslint-disable */
import { Popup, ErrorPopup, httpAxios } from "../../core/classes/BaseStore";
import $i18n from "@/i18n";
import Vue from "vue";

const tokenLifeTime = 60 * 60 * 1000;
const tokenRefresh = 10000;

var refreshTokenEvent = null;

// state
export const state = {
  user: null,
  token: null,
  logged: false,
};

// getters
export const getters = {
  user: (state) => state.user,
  token: (state) => {
    let { token } = state;

    if (token === null) {
      token = localStorage.getItem("token");
      if (token === "null") {
        token = null;
      }
    }

    return token;
  },
  logged: (state) => state.user !== null,
  ownId: (state) => (state.user ? state.user.id : false),
  fontSize: (state) => (state.user ? state.user.fontsize : "default"),
};

export const mutations = {
  setUser: (state, value) => {
    state.user = value;
    return state.user;
  },
  setToken: (state, value) => {
    state.token = value;
    localStorage.setItem("token", value);
  },
  logged: (state, value) => {
    state.logged = value;
    if (value === false) {
      state.token = null;
      state.user = null;
    }
  },
  setFontsize: (state, payload) => {
    Vue.set(state.user, "fontsize", payload);
  },
};

export const actions = {
  /**
   * Set the user store
   * @param {*} param0
   * @param {*} payload
   */
  setUser({ commit, dispatch }, payload) {
    commit("setUser", payload);
    if (payload !== null) {
      dispatch("useravatar/updateAvatar", payload.avatar, { root: true });
      dispatch("users/setUser", payload, { root: true });
    }
  },
  /**
   * Set the bearer access token
   * @param {*} param0
   * @param {*} payload
   */
  setToken({ commit, dispatch }, payload) {
    httpAxios.defaults.headers.common.Authorization = `Bearer ${payload}`;
    window.Echo.connector.pusher.config.auth.headers[
      "Authorization"
    ] = `Bearer ${payload}`;
    commit("setToken", payload);

    if (payload === null) {
      return;
    }

    if (refreshTokenEvent !== null) {
      clearTimeout(refreshTokenEvent);
    }

    refreshTokenEvent = setTimeout(() => {
      dispatch("refreshToken");
    }, tokenRefresh);
  },
  /**
   * Make api call to get the curred user
   * @param {*} param0
   * @param {*} payload
   */
  current({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      httpAxios.defaults.headers.common["Authorization"] =
        localStorage.getItem("token") !== null
          ? `Bearer ${localStorage.getItem("token")}`
          : "";

      httpAxios
        .get("/api/users/current")
        .then((response) => {
          dispatch("setUser", response.data.data);

          dispatch("notification/joinChannel", response.data.data.id, {
            root: true,
          });

          resolve(response.data.data);
        })
        .catch((error) => {
          reject(reject);
        });
    });
  },
  /**
   * Refresh the access token
   * @param {*} param0
   * @param {*} payload
   */
  refreshToken({ commit, dispatch }, payload) {
    if (getters.token === undefined) {
      return;
    }

    httpAxios.defaults.headers.common["Authorization"] =
      localStorage.getItem("token") !== null
        ? `Bearer ${localStorage.getItem("token")}`
        : "";

    httpAxios
      .get("/api/users/current-refresh")
      .then((response) => {
        if (response.status === 200) {
          dispatch("setToken", response.data.data.access_token);
        }
      })
      .catch((error) => {
        dispatch("setToken", null);
        dispatch("setUser", null);
      });
  },
  /**
   * Log in method
   * @param {*} param0
   * @param {*} payload
   */
  async login({ commit, dispatch, state }, payload) {
    return new Promise((resolve, reject) => {
      let errors;
      httpAxios
        .post("/api/auth/login", payload)
        .then(
          (response) => {
            if (response.status === 200) {
              dispatch("setToken", response.data.data.access_token);
              dispatch("current").then((response) => {
                Popup({
                  title: $i18n.t("login.success"),
                  text: $i18n.t("login.welcome", { user: response.username }),
                  type: "success",
                  autohide: 2500,
                });
              });
              resolve(response.data.data);
            }
          },
          (err) => {
            errors = err.response ? err.response.data.data.errors : null;
            ErrorPopup(err, errors);
            reject(err);
          }
        )
        .catch((error) => {
          reject(error);
        });
    });
  },
  /**
   * Create a new user account
   * @param {*} param0
   * @param {*} payload
   */
  register({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      let errors;
      httpAxios
        .post("/api/auth/register", payload)
        .then(
          (response) => {
            if (response.status === 200) {
              resolve(response.data.data);
            }
          },
          (err) => {
            errors = err.response ? err.response.data.data.errors : null;
            ErrorPopup(err, errors);
            reject(err);
          }
        )
        .catch((error) => {
          reject(error);
        });
    });
  },
  /**
   * Request new password with email
   * @param {*} param0
   * @param {*} payload
   */
  forgot({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      let errors;
      httpAxios
        .post("/api/auth/forgot", payload)
        .then(
          (response) => {
            if (response.status === 200) {
              Popup({
                title: "Passwort Wiederherstellung",
                text: response.data.data.message,
              });
              resolve(response.data.data);
            }
          },
          (err) => {
            errors = err.response ? err.response.data.data.errors : null;
            ErrorPopup(err, errors);
            reject(err);
          }
        )
        .catch((error) => {
          reject(error);
        });
    });
  },
  /**
   * Check if somebody is logged in
   * @param {*} param0
   * @param {*} payload
   */
  logged({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      if (!payload) {
        dispatch("setToken", null);
        dispatch("setUser", null);
        localStorage.removeItem("token");
        delete httpAxios.defaults.headers.common.Authorization;
      }
      resolve();
    });
  },
  /**
   * Logout
   * @param {*} param0
   * @param {*} payload
   */
  logout({ commit, dispatch }, payload) {
    dispatch("setToken", null);
    dispatch("setUser", null);
    dispatch("logged", false);
    localStorage.removeItem("token");
    delete httpAxios.defaults.headers.common.Authorization;
    setTimeout(() => {
      location.reload();
    }, 200);
  },
  /**
   * Logout
   * @param {*} param0
   * @param {*} payload
   */
  setFontsize({ commit, dispatch }, payload) {
    commit("setFontsize", payload);
  },
};
